(function () {
  function getUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) {
      return window.routes.cart_update_url;
    }

    return '/cart/update.js';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function updateCartAttributes(attributes) {
    return fetch(getUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: attributes
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('No se pudo actualizar el carrito');
      }

      return response.json();
    });
  }

  function getRoot(element) {
    return element ? element.closest('[data-rg-cart-gift]') : null;
  }

  function openDrawer(root) {
    if (!root) return;

    var drawer = root.querySelector('[data-rg-cart-gift-drawer]');

    if (!drawer) return;

    drawer.hidden = false;
    document.body.classList.add('overflow-hidden');
  }

  function closeDrawer(root) {
    if (!root) return;

    var drawer = root.querySelector('[data-rg-cart-gift-drawer]');
    var checkbox = root.querySelector('[data-rg-cart-gift-checkbox]');

    if (drawer) {
      drawer.hidden = true;
    }

    document.body.classList.remove('overflow-hidden');

    if (
      checkbox &&
      checkbox.checked &&
      root.dataset.rgCartGiftSaved !== 'true'
    ) {
      checkbox.checked = false;
    }
  }

  function updateSummary(root, toValue) {
    var summary = root.querySelector('[data-rg-cart-gift-summary]');
    var editButtons = root.querySelectorAll('[data-rg-cart-gift-open]');

    if (summary) {
      summary.hidden = false;
      summary.innerHTML = '<strong>Regalo configurado</strong>';

      if (toValue) {
        summary.innerHTML += '<br>Para: ' + escapeHtml(toValue);
      }
    }

    editButtons.forEach(function (button) {
      button.hidden = false;
    });
  }

  function clearSummary(root) {
    var summary = root.querySelector('[data-rg-cart-gift-summary]');
    var editButtons = root.querySelectorAll('[data-rg-cart-gift-open]');

    if (summary) {
      summary.hidden = true;
      summary.innerHTML = '';
    }

    editButtons.forEach(function (button) {
      button.hidden = true;
    });
  }

  function clearGift(root) {
    if (!root) return;

    root.dataset.rgCartGiftSaved = 'false';
    clearSummary(root);

    updateCartAttributes({
      'Es para regalo': '',
      'Regalo - Para': '',
      'Regalo - De': '',
      'Regalo - Mensaje': ''
    }).catch(function () {
      console.warn('No se pudo limpiar la información de regalo.');
    });
  }

  function saveGift(root, button) {
    if (!root) return;

    var checkbox = root.querySelector('[data-rg-cart-gift-checkbox]');
    var drawer = root.querySelector('[data-rg-cart-gift-drawer]');
    var toField = root.querySelector('[data-rg-cart-gift-field="to"]');
    var fromField = root.querySelector('[data-rg-cart-gift-field="from"]');
    var messageField = root.querySelector('[data-rg-cart-gift-field="message"]');

    var toValue = toField ? toField.value.trim() : '';
    var fromValue = fromField ? fromField.value.trim() : '';
    var messageValue = messageField ? messageField.value.trim() : '';

    if (button) {
      button.classList.add('is-loading');
      button.textContent = 'Guardando...';
    }

    updateCartAttributes({
      'Es para regalo': 'Sí',
      'Regalo - Para': toValue,
      'Regalo - De': fromValue,
      'Regalo - Mensaje': messageValue
    })
      .then(function () {
        root.dataset.rgCartGiftSaved = 'true';

        if (checkbox) {
          checkbox.checked = true;
        }

        updateSummary(root, toValue);

        if (drawer) {
          drawer.hidden = true;
        }

        document.body.classList.remove('overflow-hidden');
      })
      .catch(function () {
        alert('No se pudo guardar la información de regalo. Intenta nuevamente.');
      })
      .finally(function () {
        if (button) {
          button.classList.remove('is-loading');
          button.textContent = 'Guardar información de regalo';
        }
      });
  }

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('[data-rg-cart-gift-checkbox]');

    if (!checkbox) return;

    var root = getRoot(checkbox);

    if (checkbox.checked) {
      openDrawer(root);
    } else {
      clearGift(root);
    }
  });

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-rg-cart-gift-open]');

    if (openButton) {
      event.preventDefault();
      openDrawer(getRoot(openButton));
      return;
    }

    var closeButton = event.target.closest('[data-rg-cart-gift-close]');

    if (closeButton) {
      event.preventDefault();
      closeDrawer(getRoot(closeButton));
      return;
    }

    var saveButton = event.target.closest('[data-rg-cart-gift-save]');

    if (saveButton) {
      event.preventDefault();
      saveGift(getRoot(saveButton), saveButton);
      return;
    }
  });

  document.addEventListener('input', function (event) {
    var messageField = event.target.closest('[data-rg-cart-gift-field="message"]');

    if (!messageField) return;

    var root = getRoot(messageField);
    var counter = root ? root.querySelector('[data-rg-cart-gift-count]') : null;

    if (counter) {
      counter.textContent = messageField.value.length;
    }
  });
})();